import { createFileRoute } from "@tanstack/react-router";

import { PreferencesContainer } from "@/features/settings/containers/preferences-container";

export const Route = createFileRoute("/app/settings/user/preferences")({
  component: PreferencesContainer,
});
